export default "__VITE_ASSET__GQy1nIDI__"